export default "__VITE_ASSET__CDTUrOGJ__"